define('modules/ads/modals/archive_ads_modal',[
  'backbone',
  'jquery',
  '_',
  'text!./archive_ads_modal_template.html',
], function (Backbone, $, _, modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'archive-ads-modal',
    template: _.template(modal_template),

    events: {
      'click .js-archive-ads': 'archiveAds',
      'click .js-cancel': 'cancel',
    },

    render: function () {
      this.$el.html(
        this.template({
          bodyText: this.archive
            ? _.t('my_ads.modal.archive.body')
            : _.t('my_ads.modal.unarchive.body'),
          buttonText: this.archive
            ? _.t('my_ads.button.archive')
            : _.t('my_ads.button.unarchive'),
        })
      );
      return this;
    },

    archiveAds: function (e) {
      e.preventDefault();
      Backbone.trigger('ads:archive', this.archive);
      this.trigger('close');
    },

    cancel: function (e) {
      e.preventDefault();
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

